import PageTemplate from "@/components/templates/PageTemplate";
import { BlogLayout } from "@/components/blog/BlogLayout";
import { BlogMain } from "@/components/blog/BlogMain";

export default function BlogListPage() {
  return (
    <PageTemplate>
      {/* 정적 프리렌더 — 띠의 시각 판정을 요청 시각에 못 한다 (#5655 R3 x1). */}
      <PageTemplate.Content hidePromoBanner>
        <BlogLayout>
          <BlogMain />
        </BlogLayout>
      </PageTemplate.Content>
    </PageTemplate>
  );
}
